import {
  CheckCircleIcon,
  ExclamationCircleIcon,
  InformationCircleIcon,
  XCircleIcon
} from "@heroicons/react/24/solid";
import { ReactNode } from "react";
import {
  ToastContent,
  toast as toastifyToast,
  ToastOptions,
  TypeOptions
} from "react-toastify";
import { Icon } from "../../../components";

const TYPE = toastifyToast.TYPE;

const defaultIconProps = {
  className: "mr-2",
  size: 5,
  Icon: InformationCircleIcon,
  color: "gray"
};
const iconMap: { [k in TypeOptions]: ReactNode } = {
  info: <Icon {...defaultIconProps} classNameIcon="bg-info" />,
  success: (
    <Icon
      {...defaultIconProps}
      classNameIcon="bg-success"
      Icon={CheckCircleIcon}
    />
  ),
  warning: (
    <Icon
      {...defaultIconProps}
      classNameIcon="bg-warning"
      Icon={ExclamationCircleIcon}
    />
  ),
  error: (
    <Icon {...defaultIconProps} classNameIcon="bg-danger" Icon={XCircleIcon} />
  ),
  default: <Icon {...defaultIconProps} />
};

const toastWrapper = (content: ToastContent, options?: ToastOptions) => {
  const contentWithIcon = (
    <>
      {iconMap[options?.type || TYPE.DEFAULT]}
      {content}
    </>
  );
  return toastifyToast(contentWithIcon, options);
};

export const toast = Object.assign(toastWrapper, toastifyToast);

// Inspired by https://github.com/fkhadra/react-toastify/blob/master/src/core/toast.tsx#L107-L115
(["success", "info", "error", "warning"] as const).forEach((type) => {
  toast[type] = (content: ToastContent, options?: ToastOptions) =>
    toastWrapper(content, { type, ...options });
});
toast.warn = toast.warning;
